import sliderLoader from '../../vively/scripts/utils/slider-loader';

const Homepage = () => {
  if (!window.route || window.route !== 'homepage') {
    return;
  }

  sliderLoader({
    parent: '.homepage__carousel',
    slider: '.cards-slider',
    settings: {
      lazyLoad: 'progressive',
      autoplaySpeed: 3000,
      pauseOnFocus: true,
      pauseOnHover: true,
      swipeToSlide: true,
      slidesToShow: 4,
      autoplay: true,
      arrows: true,
      dots: false,
      rows: 0,
      responsive: [
        {
          settings: { arrows: false },
          breakpoint: 1200
        },
        {
          settings: { arrows: false, slidesToShow: 3 },
          breakpoint: 991
        },
        {
          settings: { arrows: false, slidesToShow: 2 },
          breakpoint: 767
        },
        {
          settings: { arrows: false, slidesToShow: 1 },
          breakpoint: 575
        }
      ]
    }
  });
};

export default Homepage;



// WEBPACK FOOTER //
// ./homepage-new/scripts/main.js